module.exports = __webpack_public_path__ + "static/media/exit.36ed48c1.svg";